export const AGENT_ENABLED = false;
export const DEFAULT_LANDING_PATH = '/run-reports';
// Draw saved-report maps from 2026 GeoEnrichment polygons (backend /report-shading,
// itself behind SHADING_2026) instead of the 2024 Esri layer. Off by default.
export const SHADING_2026_ENABLED = true;
